import { Link } from "react-router-dom";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function LibraryWelcome() {
  return (
    <div className="library-list-container fx-cl">
      <main className="librarys-main">
        <div className="acad-contents fx-cl space3">
          <header
            className="fx-cl"
            style={{ textAlign: "center", fontSize: "3.4rem" }}
          >
            <span
              style={{
                fontweight: "600",
                color: " #4CAF50",
                fontSize: "2.4rem",
              }}
            >
              {" "}
              Through Science and Compassion
            </span>
            <h2>
              Welcome to <span style={{ color: "#2f63b2" }}>Library Unit</span>
            </h2>
          </header>

          <div className="acad-discription">
            <h4>Welcome to MangaCONS Zuru.</h4>

            <p>
              We are delighted to welcome you to the Library Unit, a vital
              academic resource center of Manga College of Nursing Sciences,
              Zuru. Our library is dedicated to supporting the teaching,
              learning, and research needs of students, faculty, and staff by
              providing access to a wide range of academic resources, both in
              print and electronic formats. With a serene and conducive
              environment for study, our library is well-equipped to enhance
              your academic journey and foster a culture of inquiry, discovery,
              and lifelong learning.
            </p>

            <p>
              Our collection includes textbooks, journals, research
              publications, reference materials, and digital databases tailored
              specifically to nursing and health sciences. The Library staff are
              always available to assist users in locating information, using
              library tools, and developing essential research skills. We strive
              to maintain an inclusive and student-friendly atmosphere that
              promotes academic excellence and professional growth.
            </p>

            <p>
              Whether you're conducting in-depth research or simply looking for
              a quiet place to study, the Library Unit is here to support your
              success. We invite you to explore our services and resources and
              take full advantage of the opportunities the library provides in
              your educational pursuits.
            </p>

            <p>
              Welcome once again to the heart of academic excellence at Manga
              College of Nursing Sciences, Zuru.
            </p>
          </div>
          <div className="acad-discription g g2 rwdG2 space3">
            <div>
              <h4>Our Missions</h4>
              <p>
                At Manga College of Nursing Sciences, Zuru, our mission is to
                train skilled and dedicated nursing professionals. We are
                committed to academic excellence, ethical practice, and
                community-centered healthcare. Through quality education and
                hands-on experience, we aim to build a future-ready nursing
                workforce.
              </p>
            </div>
            <div>
              <h4>Our Visions</h4>
              <p>
                To become a leading institution in nursing education, known for
                excellence in teaching, innovation in healthcare, and commitment
                to community well-being.
              </p>
            </div>
          </div>
        </div>
        <aside className="acad-aside fx-cl space2">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt
            minus quibusdam nam at sit. Aperiam, enim voluptas praesentium harum
            impedit fugiat molestias sunt nostrum. Corrupti provident suscipit
            nobis perspiciatis soluta explicabo enim sapiente.
          </p>
        </aside>
      </main>
    </div>
  );
}
